import { useTranslation } from 'react-i18next';

import { CardItem } from '@core/components';
import { useAnalyticsEvents } from '@core/hooks/useAnalyticsEvents';
import { useRetailerSettings } from '@core/hooks/useRetailerSettings';
import useUpdateWithHistory from '@core/hooks/useUpdateWithHistory';
import { useStores } from '@ee-api/stores-api/useStores';

import { ZipCodeStores } from './zip-code-stores/zip-code-stores';

import './AddressInformation.scss';

export interface AddressInformationProps {
    step: number;
    stepInfo: string;
    emphasis?: boolean;
}

const AddressInformation = ({ stepInfo, step, emphasis = false }: AddressInformationProps): JSX.Element => {
    const { t } = useTranslation();
    const { isFetchingStores } = useStores();
    const { retailerSettings } = useRetailerSettings();
    const { setSelectedZipCodeWithHistory } = useUpdateWithHistory();
    const { trackSearchZipCode } = useAnalyticsEvents();
    const onSubmit = (code: string) => {
        setSelectedZipCodeWithHistory(code);
        trackSearchZipCode({ zipCode: code });
    };
    return (
        <CardItem
            title={t('ADDRESS_INFORMATION.INFORMATION')}
            id={step}
            stepInfo={stepInfo}
            description={t(
                retailerSettings?.isOnlineRetailer
                    ? 'ADDRESS_INFORMATION.DESCRIPTION_ONLINE'
                    : 'ADDRESS_INFORMATION.DESCRIPTION'
            )}
            emphasis={emphasis}
        >
            <ZipCodeStores loading={isFetchingStores} onSubmit={onSubmit} />
        </CardItem>
    );
};

export default AddressInformation;
